// src/hooks/useLogo.js
import logoDefault from '../assets/logo-nnnco.png';
import logoNNNCo from '../assets/logo-nnnco.png';
import logoNHUB from '../assets/logo-nhub.png';

const logoMap = {
  'commissioning.nnnco.io': logoNNNCo,
  'commissioning.n-hub.neura.co.nz': logoNHUB,
  'localhost': logoDefault,
};

const faviconMap = {
  'commissioning.nnnco.io': '/logos/nnnco-favicon.ico',
  'commissioning.n-hub.neura.co.nz': '/logos/neura-favicon.ico',
  'localhost': '/logos/nnnco-favicon.ico',
};

// Named exports instead of default
export function useLogo() {
  const hostname = window.location.hostname;
  return logoMap[hostname] || logoDefault;
}

export function useFavicon() {
  const hostname = window.location.hostname;
  return faviconMap[hostname] || '/logos/nnnco-favicon.ico';
}
